import * as Config from '../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import {
  setDimension,
  setAllowAccess
 } from "../../../actions/index";

import ContentManager from './ContentManager';
// import DynamicMenuWrapper from '../dynamic-menu/DynamicMenuWrapper';
import PlayerDropContainer from '../dnd/PlayerDropContainer';
import '../dynamic-menu/DynamicMenu.css';

let lastTap = 0;
let startY = 0;
function MainManager({ maxWidth, height, className, playerCoordinates, fullHeight, playerDrop = true }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setDimension({
      isOpen: true,
      parentWidth: maxWidth,
      width: maxWidth - (Config.CONTENT_PAD * 2) - (fullHeight ? Config.SIDE_WIDTH : Config.SIDE_WIDTH_CLOSE),
      height,
      playerCoordinates,
      fullHeight
    }));
  }, [maxWidth, height, playerCoordinates, fullHeight, dispatch]);

  // Optimise Touch Mode with the doubletap option
  useEffect(() => {
    if (Config.TOUCH_ENABLED) {
      document.getElementById(`library`).addEventListener('touchstart', e => {
        const touchobj = e.changedTouches[0];
        lastTap = new Date().getTime();
        startY = touchobj.pageY;
      });
      document.getElementById(`library`).addEventListener('touchend', e => {
        const touchobj = e.changedTouches[0];
        let currentTime = new Date().getTime();
        let tapLength = currentTime - lastTap;
        const distance = touchobj.pageY - startY;
        // if (tapLength < 300 && tapLength > 0) { // FOR DOUBLE CLICK
        if (distance > -5 && distance < 5 && tapLength > 0 && tapLength < 500) {
          dispatch(setAllowAccess(true));
          setTimeout(() => { dispatch(setAllowAccess(false)); }, 500);
          e.preventDefault();
        }
        // lastTap = currentTime; // FOR DOUBLE CLICK
      });
      document.getElementById(`library`).addEventListener('mouseup', e => {
        if (e.sourceCapabilities) {
          dispatch(setAllowAccess(true));
          setTimeout(() => { dispatch(setAllowAccess(false)); }, 500);
          e.preventDefault();
        }
      });

      const callback = (mutationsList, observer) => {
        mutationsList.forEach(mutation => {
          if (mutation.target && mutation.target.id === `play1`) {
            if (document.getElementById(`wave1_bp`)) { // OLD - wave_canvas1
              document.getElementById(`wave1_bp`).style['z-index'] = mutation.target.classList.value.includes(`button_active1`) ? 40 : -1000;
              // document.getElementById(`jump1`).style['z-index'] = mutation.target.classList.value.includes(`button_active1`) ? -1000 : 40;
            }
          }
          if (mutation.target && mutation.target.id === `play2`) {
            if ( document.getElementById(`wave2_bp`)) {
              document.getElementById(`wave2_bp`).style['z-index'] = mutation.target.classList.value.includes(`button_active2`) ? 40 : -1000;
              // document.getElementById(`jump2`).style['z-index'] = mutation.target.classList.value.includes(`button_active2`) ? -1000 : 40;
            }
          }
        })
      }
      const mutationObserver = new MutationObserver(callback);
      mutationObserver.observe(document.getElementById('play1'), { attributes: true })
      mutationObserver.observe(document.getElementById('play2'), { attributes: true })
      document.getElementById(`wave_line`).style['z-index'] = 40;

      document.getElementById("bpm_input").addEventListener(`click`, () => {
        document.getElementById("bpm_input").focus();
      })

    } else { //DEFAULT WITHOUT TOUCH

      const callbackGlobal = (mutationsList, observer) => {
        mutationsList.forEach(mutation => {
          if (mutation.target && mutation.target.id === `sfx1_lock`) {
            if (mutation.target.classList.value.includes(`sfx_lock_on1`)) {
              document.getElementById(`vinyl1`).classList.add(`lock`);
            } else {
              document.getElementById(`vinyl1`).classList.remove(`lock`);
            }
          }
          if (mutation.target && mutation.target.id === `sfx2_lock`) {
            if (mutation.target.classList.value.includes(`sfx_lock_on2`)) {
              document.getElementById(`vinyl2`).classList.add(`lock`);
            } else {
              document.getElementById(`vinyl2`).classList.remove(`lock`);
            }
          }
          if (mutation.target && mutation.target.id === `sfx1_board`) {
            if (mutation.target.style.transform.includes(`215`)) {
              document.getElementById(`vinyl1`).classList.add(`fx`);
            } else {
              document.getElementById(`vinyl1`).classList.remove(`fx`);
            }
          }
          if (mutation.target && mutation.target.id === `sfx2_board`) {
            if (mutation.target.style.transform.includes(`-210`)) {
              document.getElementById(`vinyl2`).classList.add(`fx`);
            } else {
              document.getElementById(`vinyl2`).classList.remove(`fx`);
            }
          }

          if (mutation.target && mutation.target.id === `wave_editor1`) {
            if (mutation.addedNodes.length > 0) { document.getElementById(`wave_editor1`).classList.add(`on`); }
            else { document.getElementById(`wave_editor1`).classList.remove(`on`); }
          }
          if (mutation.target && mutation.target.id === `wave_editor2`) {
            if (mutation.addedNodes.length > 0) { document.getElementById(`wave_editor2`).classList.add(`on`); }
            else { document.getElementById(`wave_editor2`).classList.remove(`on`); }
          }

        })
      }
      const mutationGlobalObserver = new MutationObserver(callbackGlobal);
      const observeMutation = (id, options) => {
        const el = document.getElementById(id);
        if (el) { mutationGlobalObserver.observe(el, options) }
      }
      observeMutation('sfx1_lock', { attributes: true });
      observeMutation('sfx2_lock', { attributes: true });
      observeMutation('sfx1_board', { attributes: true });
      observeMutation('sfx2_board', { attributes: true });
      observeMutation('wave_editor1', { childList: true });
      observeMutation('wave_editor2', { childList: true });

      dispatch(setAllowAccess(true));
    }
  },[dispatch])

  return (
    <div id={`lmc`} className={`main-content ${className}`} style={{ height }}>
      <ContentManager />
      {playerDrop && <PlayerDropContainer />}
      {/* <DynamicMenuWrapper /> */}
    </div>
  );
}

MainManager.propTypes = {
  maxWidth: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  className: PropTypes.string,
  playerCoordinates: PropTypes.object.isRequired,
  fullHeight: PropTypes.bool.isRequired,
  playerDrop: PropTypes.bool
}

export default MainManager;
